<template>
  <div class="main">
    <div class="loading" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>
    <div class="record" ref="list" id="list">
      <div v-for='(item, index) in recordList.list' :key='index' class="record-list-item">
        <div>
          <div>{{ item.name }}</div>
          <div>{{ item.schoolName }}</div>
        </div>
        <div @click="onGoRecord(item)" class="record-select">选择</div>
      </div>
    </div>
    <div class="submit-btn-box">
      <van-button class="submit-btn" @click="onGoAdd">添加</van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'uniapp-user',
  data() {
    return {
      showLoading: 1,
      recordList: { list: '' },
      page: 1,
      pageType: 1,
      isLoad: false,
      openId: '',
      hospitalId: '',
      schoolId: '',
      archId: ''
    };
  },
  mounted() {
    document.title = '检查人列表';
    const _this = this;
    this.openId = this.$route.query.openId;
    this.hospitalId = this.$route.query.hospitalId || '';
    this.schoolId = this.$route.query.schoolId || '';
    this.pageType = this.$route.query.pageType;
    this.onGetData();
    window.addEventListener('scroll', function () {
      const scroll = document.documentElement.scrollTop || document.body.scrollTop
      const winHeight = document.body.clientHeight && document.documentElement.clientHeight
      if (_this.$refs.list != null) {
        const listHeight = _this.$refs.list.offsetHeight
        if (scroll >= listHeight - winHeight - 80) {
          _this.page++;
          _this.onGetData(_this.openId);
        }
      }
    })

  },
  methods: {
    /**
     * 获取数据
    */
    async onGetData() {
      const auth = this.$createAuth(this.$md5);
      const _this = this;
      if (!this.isLoad) {
        this.isLoad = true;
        const result = await this.$http.get(this.$url.relatedStudents, {
          openId: this.openId,
          page: this.page,
          hospitalId: this.hospitalId,
          pageSize: 30,
          auth: auth.code,
          time: auth.time
        });
        if (result.message === 'Error: Miss auth parameter.') {
          setTimeout(()=> {
            _this.showLoading = 0;
            _this.isLoad = false;
            _this.onGetData(openId);
          }, 500);
        } else {
          this.showLoading = 0;
          const list = [...this.recordList.list, ...result.data.studentList.list]
          this.recordList.list = list;
          this.isLoad = false;
        }
      }
    },
    onGoRecord(item) {
      // 选择进入默认页面
      // localStorage.setItem("record_select", JSON.stringify(item));
      // // 0626 跳转到分析页面
      // if (this.pageType == 2) {
      //   this.$router.push(`/uniapp/analysis?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&uid=${item.uid}&studentIds=${item.studentIds}`);
      // }else {
      //   this.$router.push(`/uniapp/record?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&uid=${item.uid}&studentIds=${item.studentIds}&pageType=${this.pageType}`);
      // }
      //先给这个人登记下吧--必须返回档案表id，传给下个页面
      this.addStudentId(item);

      
    },

    async addStudentId(item){
      if(item.student_id){
        const auth = this.$createAuth(this.$md5);
        const _this = this;
        if (!this.isLoad) {
          this.isLoad = true;
          const result = await this.$http.post(this.$url.studentAddByStudent, {
            openId: this.openId,
            hospitalId: this.hospitalId,
            studentId: item.student_id,
            auth: auth.code,
            time: auth.time
          });
          if (result.message === 'Error: Miss auth parameter.') {
            setTimeout(()=> {
              _this.showLoading = 0;
              _this.isLoad = false;
              _this.addStudentId(item);
            }, 500);
          } else {
            this.showLoading = 0;
            this.isLoad = false;
            this.archId = result.data.archId
            //进入到检查结果补录页面
            this.$router.push(`/uniapp/achives?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&schoolId=${this.schoolId}&pageType=${this.pageType}&showNew=1&archId=${this.archId}`);
          }
        }
      }
    },

    onGoAdd() {
      this.$router.push(`/uniapp/achives?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&pageType=${this.pageType}`);
    }
  },
};
</script>
<style scope lang="less">
.main {
  width: 100vw;
  height: 100vh;
  background: #f4f4f4;
}
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.plus {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;

  img {
    width: 0.5rem;
  }
}

.record {
  .record-list-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.1rem;
    padding: 0.3rem;
    background: #fff;
    border-left: 0.05rem solid #42b983;
    div {
      line-height: 1.6em;
      text-align: left;
      &.record-select {
        width: 1.5rem;
        height: 1.8em;
        margin-top: 0.5em;
        line-height: 1.8em;
        text-align: center;
        color: #42b983;
      }
    }
  }
}
.submit-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 6.9rem;
  padding: 0.3rem;
  background: #fff;

  .submit-btn {
    width: 6.9rem;
    background-color: #5CC4AB;
    color: #fff;
    border-radius: 5px;
  }
}
</style>
